import { PlateType } from '__generated__/globalTypes';

export const MAX_ALLOWED_MODS = 2;
const MAX_ALLOWED_MODS_384 = 1;

export const getMaxAllowedMods = (plateType: PlateType | undefined | null) => {
  return plateType === PlateType.PLATE_384 ? MAX_ALLOWED_MODS_384 : MAX_ALLOWED_MODS;
};
